import classnames from 'classnames';
import { FC } from 'react';
import style from './style';

interface IProps {
  overrideClassname?: string;
}
const OaImageDropzone: FC<IProps> = ({ overrideClassname = '' }) => {
  const classes = style();
  return <div className={classnames(classes.dropzoneContainer, overrideClassname)}>content</div>;
};

export default OaImageDropzone;
